import { useMemo } from 'react';

import { RedactionDisplayStatus } from '~/core/shared/constants';
import { getRedactionDisplayConfig } from '../../logic/getRedactionDisplayConfig';

export const useRedactionDisplayConfig = (
  status?: RedactionDisplayStatus,
): ReturnType<typeof getRedactionDisplayConfig> => {
  const displayConfig = useMemo(
    () => getRedactionDisplayConfig(status),
    [status],
  );

  return displayConfig;
};
